var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Form dependencies"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  !_vm.initialized
                    ? _c("h4", [
                        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                        _vm._v(
                          " Checking dependencies...\n                    "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.initialized
                    ? _c(
                        "div",
                        [
                          _c(
                            "div",
                            {
                              staticClass: "alert alert-warning text-dark",
                              attrs: { role: "alert" },
                            },
                            [
                              _c("p", [
                                _vm._v("The form '"),
                                _c("strong", [_vm._v(_vm._s(_vm.name))]),
                                _vm._v("' is used in "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.dependantsCount)),
                                ]),
                                _vm._v(" places."),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("FormDependenciesList", {
                            attrs: { readModel: _vm.deps },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Close")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }